import { Provider } from '@angular/core';

import { InternalNotificationsApiService } from './internal-notifications-api.service';
import { InternalNotificationsHttpService } from './internal-notifications-http.service';

/**
 * Registra la implementación de `InternalNotificationsApiService` que usa la
 * app. Misma forma que `provideMailing()`.
 */
export function provideInternalNotifications(): Provider[] {
  return [{ provide: InternalNotificationsApiService, useClass: InternalNotificationsHttpService }];
}
